const initialState = {
	dialogVisible: false,
	entity: {}
};


export default {
	state: {
		...initialState
	},

	mutations: {

		edit (state, args) {
			if (args) {
				[ state.entity ] = args;
				state.dialogVisible = true;
			} else {
				for (let prop in initialState) {
					state[prop] = initialState[prop];
				}
			}
		},

		create (state) {
			state.entity = {};
			state.dialogVisible = true;
		},

		hide (state) {
			state.dialogVisible = false;
		},

		cancel (state) {
			for (let prop in initialState) {
				state[prop] = initialState[prop];
			}
		}

	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogue/edit.js